var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpdate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: 9.858,
    y1: 9.858,
    x2: 38.142,
    y2: 38.142,
    gradientUnits: "userSpaceOnUse",
    id: "color-1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#03a4fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#038387"
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(5.33333,5.33333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44,24c0,11.045 -8.955,20 -20,20c-11.045,0 -20,-8.955 -20,-20c0,-11.045 8.955,-20 20,-20c11.045,0 20,8.955 20,20z",
    fill: "url(#color-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.015,15.079c-0.297,-0.301 -0.778,-0.317 -1.077,-0.018l-2.795,2.795c-0.272,0.272 -0.269,0.699 -0.021,0.993c3.257,3.865 1.569,9.537 -1.962,11.534c-1.291,0.73 -5.064,0.858 -7.126,-0.57c-2.249,-1.557 -5.077,-6.463 -2.162,-9.942l2.147,2.147c0.731,0.732 1.981,0.214 1.981,-0.821v-8.197c0,-0.552 -0.448,-1 -1,-1h-8.468c-0.934,0 -1.402,1.13 -0.742,1.791l2.25,2.25c-4.183,4.705 -4.045,12.078 0.374,16.735c4.55,4.794 12.973,5.637 17.651,1.435c4.955,-4.451 7.543,-12.46 0.95,-19.132z",
    fill: "#000000",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.015,15.579c-0.289,-0.308 -0.778,-0.317 -1.077,-0.018l-2.287,2.287c-0.277,0.277 -0.273,0.711 -0.022,1.01c3.109,3.7 1.964,9.273 -1.846,11.674c-1.969,1.24 -5.624,1.314 -7.972,-0.285c-3.181,-2.162 -4.879,-7.369 -1.941,-10.876l2.037,2.037c0.587,0.587 1.592,0.171 1.592,-0.659v-7.249c0,-0.552 -0.448,-1 -1,-1h-7.384c-0.781,0 -1.172,0.944 -0.62,1.496l2.044,2.044c-4.235,4.764 -4.035,12.185 0.595,16.754c4.541,4.495 12.363,4.917 16.969,0.719c4.892,-4.458 6.316,-12.171 0.912,-17.934z",
    fill: "#000000",
    opacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.409,30.682c-2.634,1.771 -6.184,1.771 -8.817,0c-4.323,-2.907 -4.739,-8.848 -1.248,-12.339l-2.828,-2.828c-4.79,4.79 -4.676,12.654 0.341,17.298c4.532,4.195 11.754,4.196 16.287,0.002c4.826,-4.465 5.117,-11.911 0.873,-16.736c-0.279,-0.317 -0.778,-0.317 -1.077,-0.018l-1.78,1.779c-0.282,0.282 -0.278,0.723 -0.022,1.028c2.96,3.536 2.384,9.048 -1.729,11.814z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,13h-6.3c-0.627,0 -0.941,0.758 -0.498,1.202l6.596,6.596c0.444,0.444 1.202,0.129 1.202,-0.498v-6.3c0,-0.552 -0.448,-1 -1,-1z",
    fill: "#ffffff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdate);
export default __webpack_public_path__ + "static/media/update.14d311dda50b79e173d9f8473e11cbec.svg";
export { ForwardRef as ReactComponent };